import React, { useRef } from "react";
import email from "./email.png";
import emailjs from "emailjs-com";
import "./Contact.css";
import LightSpeed from "react-reveal/LightSpeed";
import { useState } from "react";

const Contact = () => {
  const inputRef = useRef({});

  const [userInput, setUserInput] = useState({
    Name: false,
    Email: false,
    Message: false,
  });

  const handleName = () => {
    if (inputRef.current["Name"].value == false) {
      const newUserInput = { ...userInput };
      newUserInput.Name = true;
      setUserInput(newUserInput);
    } else {
      const newUserInput = { ...userInput };
      newUserInput.Name = false;
      setUserInput(newUserInput);
    }
  };

  const handleEmail = () => {
    if (/\S+@\S+\.\S+/.test(inputRef.current["Email"].value)) {
      console.log(/\S+@\S+\.\S+/.test(inputRef.current["Email"].value));
      const newUserInput = { ...userInput };
      newUserInput.Email = false;
      setUserInput(newUserInput);
      console.log("wrong");
    } else {
      const newUserInput = { ...userInput };
      newUserInput.Email = true;
      setUserInput(newUserInput);
      console.log("wrong");
    }
  };

  const handleMessage = () => {
    if (inputRef.current["messege"].value == false) {
      const newUserInput = { ...userInput };
      newUserInput.Message = true;
      setUserInput(newUserInput);
    } else {
      const newUserInput = { ...userInput };
      newUserInput.Message = false;
      setUserInput(newUserInput);
    }
  };

  function sendEmail(e) {
    e.preventDefault();

    if (userInput.Name || userInput.Email || userInput.Message) {
      // console.log(Name, Email, messege);
      console.log("validate correctly");
      return false;
    } else {
      emailjs
        .sendForm(
          "service_0sk62tp",
          "template_5zdz1qc",
          e.target,
          "user_caagFYsbH7sk7neERYGJ1"
        )
        .then(
          (result) => {
            console.log(result.text);
          },
          (error) => {
            console.log(error.text);
          }
        );
      e.target.reset();
    }
  }

  return (
    <div className="main">
      <h3
        className="text-center"
        style={{ color: "#df5c04", paddingTop: "100px" }}
      >
        Feel free to contact me
      </h3>

      <div
        className="container d-flex text-white py-5 flex-wrap justify-content-center align-items-center contact"
        style={{ height: "520px" }}
      >
        <LightSpeed left>
          <div style={{ margin: "2px 10px" }}>
            <img src={email} alt="" width="500px" className="img" />
          </div>
        </LightSpeed>
        <LightSpeed right>
          <div style={{ width: "500px" }}>
            <form
              className="contact-form"
              onSubmit={sendEmail}
              autoComplete="off"
            >
              <div className="py-1 my-2">
                <input
                  type="text"
                  ref={(el) => (inputRef.current["Name"] = el)}
                  className="form-control input"
                  placeholder="Enter your name"
                  name="user_name"
                  autoComplete="off"
                  onChange={handleName}
                  required
                />
                {userInput.Name ? (
                  <small style={{ color: "red" }}>Put valid input</small>
                ) : (
                  false
                )}
              </div>
              <div className="py-1 my-2">
                <input
                  type="email"
                  ref={(el) => (inputRef.current["Email"] = el)}
                  className="form-control input"
                  placeholder="Enter your email"
                  name="user_email"
                  autoComplete="off"
                  onChange={handleEmail}
                  required
                />
                {userInput.Email && (
                  <small style={{ color: "red" }}>Put valid input</small>
                )}
              </div>

              <div className="py-1">
                <textarea
                  name="message"
                  ref={(el) => (inputRef.current["messege"] = el)}
                  className="form-control input"
                  placeholder="Enter your message"
                  rows="5"
                  onChange={handleMessage}
                  required
                />
                {userInput.Message && (
                  <small
                    style={{ color: "red", marginTop: "0", paddingTop: "0" }}
                  >
                    Put valid input
                  </small>
                )}
                <br />
                <input type="submit" value="Send" className="py-2 submit" />
              </div>
            </form>
          </div>
        </LightSpeed>
      </div>
    </div>
  );
};

export default Contact;
